<template>
  <div>

    <!-- activator -->
    <mdb-btn class="btn-sm" @click.native="modal = true">Change</mdb-btn>

    <mdb-modal v-if="modal" @close="cancel">

      <!-- header -->
      <mdb-modal-header class="isi-heading-blue">Locations</mdb-modal-header>

      <!-- body -->
      <mdb-modal-body>
        <form v-on:submit.prevent v-on:keyup.enter="submit" @submit="submit">

          <!-- continent form field -->
          <div class="my-1 mb-2">
            <div class="pb-1">
              <select id="continentSelect" v-model="continentId" class="browser-default custom-select">
                <option v-for="item in sortedContinents" :key="item.id" :value="item.id">{{ item.name }}</option>
              </select>
            </div>

            <!-- label -->
            <div class="select-label" :class="[continentId ? 'selected' : '']">
              <span class="p-0 px-1 m-0">Continent</span>
            </div>
          </div>
          
          <!-- country form field -->
          <div class="my-1 mb-2">
            <div class="d-flex flex-row align-items-center">
              <div class="w-75">
                <select id="countrySelect" v-model="countryId" class="browser-default custom-select" :disabled="!this.continentId || this.newCountry">
                  <option v-for="item in countriesSelectItems" :key="item.id" :value="item.id">{{ item.name }}</option>
                </select>
              </div>
              <mdb-btn icon="plus" class="w-25 px-2 btn-sm" @click="() => { this.newCountry = { name: null, latitude: null, longitude: null }; this.countryId = null; this.newCity = { displayName: null, latitude: null, longitude: null }; this.cityId = null; }" :disabled="!this.continentId || this.newCountry != null">New Country</mdb-btn>
            </div>

            <!-- label -->
            <div class="select-label" :class="[(countryId || newCountry) ? 'selected' : '']">
              <span class="p-0 px-1 m-0">Country</span>
            </div>
          </div>

          <!-- new country section -->
          <div v-if="newCountry" class="p-2 mb-4" style="border: 1px solid #00000020; border-radius: 0.2em;">
            <div class="d-flex flex-row justify-content-between align-items-center">
              <p class="m-0 mb-2">New Country</p>
              <a flat class="close py-2 px-2 mx-2 mb-2" style="font-weight: 500;" @click="() => { this.newCountry = null, this.newCity = null; }">x</a>
            </div>

            <mdb-input v-model="newCountry.name" class="m-0" type="text" outline id="newCityTextField" label="Country" />
            
            <section class="py-2">
              <p class="m-0 mb-1" style="font-size:0.9em; font-weight: 100;">Coordinate</p>
              <p style="color:orangered"><small style="color:orangered">Coordinates must be comma seperated</small></p>
              <div class="d-flex flex-row">
                <mdb-input v-model="newCountry.latitude" placeholder="51,54237500497245" class="m-0 w-100 mr-1" type="text" outline label="Latitude" />
                <mdb-input v-model="newCountry.longitude" placeholder="9,915718688238323" class="m-0 w-100 ml-1" type="text" outline label="Longitude" />
              </div>
            </section>
          </div>

          <!-- city form field-->
          <div class="my-1 mb-2">
            <div class="d-flex flex-row align-items-center">
              <div class="w-75">
                <select id="citySelect" v-model="cityId" class="browser-default custom-select" :disabled="!this.countryId || this.newCity">
                  <option v-for="item in citiesSelectItems" :key="item.id" :value="item.id">{{ item.displayName }}</option>
                </select>
              </div>
              <mdb-btn icon="plus" class="w-25 px-2 btn-sm" @click="() => { this.newCity = { displayName: null, latitude: null, longitude: null }; this.cityId = null; }" :disabled="!this.countryId || this.newCity != null">New City</mdb-btn>
            </div>

            <!-- label -->
            <div class="select-label" :class="[(cityId || newCity) ? 'selected' : '']">
              <span class="p-0 px-1 m-0">City</span>
            </div>
          </div>

          <!-- new city section -->
          <div v-if="newCity" class="p-2 mb-2" style="border: 1px solid #00000020; border-radius: 0.2em;">
            <div class="d-flex flex-row justify-content-between align-items-center">
              <p class="m-0 mb-2">New City</p>
              <a flat v-if="newCountry == null" class="close py-2 px-2 mx-2 mb-2" style="font-weight: 500;" @click="newCity = null">x</a>
            </div>

            <mdb-input v-model="newCity.displayName" class="m-0" type="text" outline id="newCityTextField" label="City" />
            
            <section class="py-2">
              <p class="m-0 mb-1" style="font-size:0.9em; font-weight: 100;">Coordinate</p>
              <p style="color:orangered"><small style="color:orangered">Coordinates must be comma seperated</small></p>
              <div class="d-flex flex-row">
                <mdb-input v-model="newCity.latitude" placeholder="51,54237500497245" class="m-0 w-100 mr-1" type="text" outline label="Latitude" />
                <mdb-input v-model="newCity.longitude" placeholder="9,915718688238323" class="m-0 w-100 ml-1" type="text" outline label="Longitude" />
              </div>
            </section>
          </div>

          <section class="py-2">
            <p class="m-0 mb-1" style="font-size:0.9em; font-weight: 100;">Coordinate</p>
            <div class="d-flex flex-row">
              <mdb-input v-model="geoCoordinate.latitude" class="m-0 w-100 mr-1" type="text" outline :label="(this.geoCoordinate?.latitude != null && this.geoCoordinate?.latitude != '') ? 'Latitude': null" placeholder="Latitude (optional)" />
              <mdb-input v-model="geoCoordinate.longitude" class="m-0 w-100 ml-1" type="text" outline :label="(this.geoCoordinate?.longitude != null && this.geoCoordinate?.longitude != '') ? 'Longitude': null" placeholder="Longitude (optional)" />
            </div>
          </section>

        </form>

        <!-- validation message -->
        <p v-if="validationMessage" class="m-0 text-danger" style="font-size: 0.9em; font-weight: 100;">{{ validationMessage }}</p>

      </mdb-modal-body>

      <!-- footer -->
      <mdb-modal-footer>
        <mdb-btn color="grey" class="btn-sm" @click.native="cancel">Cancel</mdb-btn>
        <mdb-btn color="isi" class="btn-sm" @click.native="submit">Ok</mdb-btn>
      </mdb-modal-footer>

    </mdb-modal>
  </div>
</template>

<script>
import sortContinents from "@/modules/sortContinents";

export default {
  props: {
    options: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      modal: false,
      continentId: null,
      countryId: null,
      newCountry: null,
      cityId: null,
      newCity: null,
      geoCoordinate: { 
        latitude: null, 
        longitude: null
      },
      locationData: {
        cityData: null
      },
      validationMessage: null,
    };
  },
  async mounted() {
    await this.setDataByLocationObject(this.options);
  },
  computed: {
    // computed properties
    sortedContinents() {
      const mapped = this.$store.state.allContinents.map(c => ({ ...c, displayName: c.name }));
      return sortContinents(mapped);
    },
    countriesSelectItems() {
      let selectableCountries = this.$store.state.allCountries
        .filter(el => el.continentData.id == this.continentId)
        .sort((a, b) => {
          if (a.name < b.name) return -1;
          if (a.name > b.name) return 1;
          return 0;
        });

      if (this.newCountry != null) {
        const selectedContinent = this.$store.state.allContinents.find(el => el.id == this.continentId);

        selectableCountries.unshift({
          id: null,
          name: this.newCountry.name,
          continentData: selectedContinent,
        });
      }

      return selectableCountries;
    },
    citiesSelectItems() {
      let selectableCities = this.$store.state.allCities
        .filter(el => el.countryData.id == this.countryId)
        .sort((a, b) => {
          if (a.displayName < b.displayName) return -1;
          if (a.displayName > b.displayName) return 1;
          return 0;
        });

      selectableCities.unshift({
        id: null,
        displayName: "",
      });

      if (this.newCity != null) {
        const selectedCountry = this.$store.state.allCountries.find(el => el.id == this.countryId);

        selectableCities.unshift({
          id: null,
          displayName: this.newCity.displayName,
          countryData: selectedCountry,
        });
      }

      return selectableCities;
    },
  },
  watch: {
    continentId() {
      this.countryId = null;
      this.cityId = null;
    },
    countryId() {
      this.cityId = null;
    },
    cityId() {
      this.locationData.cityData = this.$store.state.allCities.find(el => el.id == this.cityId);
    },
  },
  methods: {
    async setDataByLocationObject(locationData) {
      this.locationData = JSON.parse(JSON.stringify(locationData));

      if (!locationData?.cityData) {
        this.locationData = {
          cityData: null,
        };

        this.geoCoordinate = { 
          latitude: null, 
          longitude: null
        },
        this.continentId = null;
        this.countryId = null;
        this.newCountry = null;
        this.cityId = null;
        this.newCity = null;

        return;
      }

      this.geoCoordinate = { 
        latitude: null, 
        longitude: null
      };

      if (this.locationData.geoCoordinate)
        this.geoCoordinate = this.locationData.geoCoordinate;

      await this.setContinentId();
      await this.setCountryId();
      await this.setCity();
    },
    async cancel() {
      await this.setDataByLocationObject(this.options);
      this.modal = false;
    },
    submit() {
      // submit logic
      this.validateForm();
      if (this.validationMessage) return;

      let locationData = { cityData: null, geoCoordinate: null };
      if (this.cityId != null) {
        locationData.cityData = this.$store.state.allCities.find(el => el.id == this.cityId);
        locationData.cityData.countryData.continentData.geoCoordinate = null;
        locationData.geoCoordinate = this.geoCoordinate;
        
        this.$emit("submit", locationData);
        this.modal = false;
        return;
      }

      let countryData = this.$store.state.allCountries.find(el => el.id == this.countryId) ?? this.newCountry;
      countryData.continentData ??= this.$store.state.allContinents.find(el => el.id == this.continentId);

      let cityData = this.newCity;
      cityData.countryData = countryData;

      locationData.cityData = cityData;
      locationData.cityData.countryData.continentData.geoCoordinate = null;
      locationData.geoCoordinate = this.geoCoordinate;
      this.$emit("submit", locationData);
      this.modal = false;
    },
    validateForm() {
      if (this.continentId == null) {
        this.validationMessage = "Please select continent, country and city.";
        return;
      }

      if (this.countryId == null && this.newCountry == null) {
        this.validationMessage = "Please select country and city.";
        return;
      }

      if (this.newCountry != null) {
        if ((this.newCountry.name == null || this.newCountry.name == "") || (this.newCountry.latitude == null || this.newCountry.latitude == "") || (this.newCountry.longitude == null || this.newCountry.longitude == "")) {
          this.validationMessage = "Please fill in a name, latitude and longitude for a new country.";
          return;
        }
      }

      if (this.cityId == null && this.newCity == null) {
        this.validationMessage = "Please select a city.";
        return;
      }

      if (this.newCity != null) {
        if ((this.newCity.displayName == null || this.newCity.displayName == "") || (this.newCity.latitude == null || this.newCity.latitude == "") || (this.newCity.longitude == null || this.newCity.longitude == "")) {
          this.validationMessage = "Please fill in a name, latitude and longitude for a new city.";
          return;
        }
      }

      this.validationMessage = null;
    },
    async setContinentId() {
      return new Promise((resolve) => {
        this.continentId = this.locationData?.cityData?.countryData?.continentData?.id;
        resolve();
      });
    },
    async setCountryId() {
      return new Promise((resolve) => {
        this.countryId = this.locationData?.cityData?.countryData?.id;
        this.newCountry = null;
        resolve();
      });
    },
    async setCity() {
      return new Promise((resolve) => {
        this.cityId = this.locationData?.cityData?.id;
        this.newCity = null;
        resolve();
      });
    },
  },
};
</script>

<style scoped>
.select-label.selected {
  margin-top: -3.7em !important;
}
</style>